import React, { Component } from 'react'
import { connect } from 'react-redux'
import AppContentComponent from '../../templates/content'
import { Route } from 'react-router-dom'
import AppCampaignsListComponent from "../campaigns/components";
// import AppCampaignsCreateComponent from "../campaigns/components/create";
import AppCampaignsUpdateComponent from "../campaigns/components/update";

class AppCampaignsComponent extends Component {
		render() {

			return (
				<AppContentComponent>
					{/*<Route exact path="/app/campaigns/create" component={AppCampaignsCreateComponent} />*/}
					<Route exact path="/app/campaigns/campaign/:campaign_id" component={AppCampaignsUpdateComponent} />
					<Route exact path="/app/campaigns/" component={AppCampaignsListComponent} />
				</AppContentComponent>
			)
		}
}

const mapStateToProps = (state) => {
	return {}
};

export default connect(mapStateToProps)(AppCampaignsComponent)


// WEBPACK FOOTER //
// ./src/application/components/campaigns/index.js